const React = require("react");

function DeviceTabletIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
  }));
}

module.exports = DeviceTabletIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/DeviceTabletIcon.js
 ** module id = 505
 ** module chunks = 0
 **/